<template lang="pug">
  .section.expertise-included
    .xs-12.md-6.lg-5.lg-offset-1
      SectionTitle(text="Expertise Included").text-center
      .top-wrap.text-center
        p.xs-f-small.lg-f-medium.max-at-tweak Any questions? Our licensed professional colorists are here to help.

    .xs-12.md-6.lg-5
      SupportCtas

</template>

<script>
  import SupportCtas from "../SupportCtas";
  import SectionTitle from "../SectionTitle";
  
  export default {
    name: 'ExpertiseIncluded',
    components: {
      SectionTitle,
      SupportCtas
    }
  }
</script>

<style scoped lang="stylus">
  .expertise-included
    padding 2em 0
    margin-bottom 1.5em
    
    .top-wrap
      padding 1.5em 0

    @media mq-desktop
      .top-wrap
        margin auto
        max-width 20em

</style>
